export class OrganizationIndexingErrorInfo {
    OrganizationId: string;
    OrganizationName: string;
    Total: number;
    AppPropertyErrorKeys: string[];
}
